import * as Yup from "yup";

export const formValidationMap = Yup.object().shape({
    link_map: Yup.string().required("Map is required !")
});
